export default __webpack_public_path__ + "static/media/(52).8aa5a5b1.jpg";